import * as React from "react";
import {
  Text,
  Image,
  View,
  StyleSheet,
  ScrollView,
  Platform,
  Linking,
} from "react-native";
import GlobalStyles from "../../components/GlobalStyles.js";
import StatusBar from "../../components/headers/StatusBar";
import Barcode from "../../components/Barcode";
import { useSelector } from "react-redux";
import { shellGetBarcode } from "../../redux/actions/PartnerActions.js";
import BackButtonTopWhite from "../../components/BackButtonTopWhite";
import Colors from "../../utilities/Color.js";
import { Shadow } from "react-native-shadow-2";
export default function ShellBarcodeScreen() {
  const BGimage = require("../../assets/res/blue_bg.png");
  const MenuLogo = require("../../assets/res/Aura_Alpha_Reversed_BlueBG.gif");
  const shellLogo = require("../../assets/images/shell/shellIcon.png");
  const saveIcon = require("../../assets/images/shell/saveIconBarcode.png");

  const promoLoaded = useSelector((state) => state.partners.promoLoaded);
  const barcodeNumber =
    useSelector((state) => state.partners.promoData.shellBarcode) || "0";

  React.useEffect(() => {
    // 1800000 = 30m * 60s * 1000ms
    const timer = setInterval(() => shellGetBarcode(), 1800000);
    return () => clearInterval(timer);
  }, []);

  if (!promoLoaded) {
    shellGetBarcode();
  }

  return (
    <ScrollView style={styles.scrollView}>
      <View style={GlobalStyles.containerN}>
        <View style={GlobalStyles.backgroundContainer}>
          <Image style={GlobalStyles.backgroundImage} source={BGimage} />
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.backButtonContainer}>
            <BackButtonTopWhite />
          </View>
          <View style={styles.mainMenuLogoContainer}>
            <Image style={styles.mainMenuLogo} source={MenuLogo} />
          </View>
          <View style={styles.forwardButtonContainer}></View>
        </View>
        <View>
          <View style={styles.bodyContainerFull}>
            <View style={styles.upperTextContainer}>
              <Text style={styles.topText}>
                Present this barcode at Shell Coles Express to redeem
                your 3¢ per litre cash back reward.^
              </Text>
            </View>
            <View style={styles.listPaddingContainer}>
              <Shadow
                distance={3}
                startColor="#44a1cd"
                endColor={Colors.MIDBLUE}
                offset={[0, 0]}
                style={styles.shadowcorners}
              >
                <View style={styles.whiteSquareContainerF}>
                  <View style={styles.headerTextP}>
                    <View style={styles.fuelPartnerTextContainer}>
                      <Text style={styles.fuelPartnerTextStyle}>Fuel Partner</Text>
                    </View>
                    <View style={styles.ShellLogoContainer}>
                      <Image style={styles.shellLogo} source={shellLogo} />
                    </View>
                    <View style={styles.barcodeTextContainer}>
                      <Barcode
                        value={barcodeNumber}
                        options={{
                          format: "CODE128",
                          background: "#ffffff",
                          font: "courier",
                          height: 60,
                          width: 2,
                          margin: 20,
                        }}
                      />
                    </View>
                    <View style={styles.fuelPartnerTextContainer}>
                      <Text style={styles.fuelPartnerTextStyleBlue}>
                        Cash back can take 1-2 days to appear in your Transactions.
                      </Text>
                    </View>
                  </View>
                </View>
              </Shadow>
            </View>
            <View style={styles.footerTextContainer}>
              <Text style={styles.middelTextGrey}>
                <Text style={styles.middelTextGrey}>
                  ^Barcode valid for single use per day. Once redeemed you will
                  be eligible for a new barcode after 9am the next calendar day.
                  Excludes LPG & Adblue. Min 2L and max 150L per transaction.
                  See full&nbsp;
                </Text>
                <Text
                  style={[
                    styles.middelTextGrey,
                    { textDecorationLine: "underline" },
                  ]}
                  onPress={() => {
                    Platform.OS !== "web"
                      ? Linking.openURL(
                        "https://aura.club/promotional-terms-and-conditions"
                      )
                      : window.open(
                        "https://aura.club/promotional-terms-and-conditions",
                        "_blank"
                      );
                  }}
                >
                  terms here.
                </Text>
              </Text>
            </View>
            <View style={styles.middelTextContainer}>
              <Text style={styles.pleaseText}>
                Please remember not to use your mobile phone on the service
                station forecourt.
              </Text>
            </View>
            <View style={styles.threeLogoContainer}>
              <Image style={styles.saveIconLogo} source={saveIcon} />
            </View>
            <View style={styles.termTextContainer}>
              <Text style={styles.middelTextGrey}>
                *3¢ per litre deposited from your qualifying Shell fuel purchase into your Aura account.
              </Text>
            </View>
            <View style={styles.bottonTextContainer}>
              <Text style={styles.middelTextGrey}>
                <Text style={styles.middelTextGrey}>
                  # ‘Coles Supermarkets Fuel Docket Discount’ and the ‘Spend $20
                  get 10¢ per litre fuel discount’ made available by Coles Express at Shell
                  Coles Express service stations, subject to the Coles Express
                  &nbsp;
                </Text>
                <Text
                  style={[
                    styles.middelTextGrey,
                    { textDecorationLine: "underline" },
                  ]}
                  onPress={() => {
                    Platform.OS !== "web"
                      ? Linking.openURL(
                        "https://www.coles.com.au/coles-express/terms-and-conditions"
                      )
                      : window.open(
                        "https://www.coles.com.au/coles-express/terms-and-conditions",
                        "_blank"
                      );
                  }}
                >
                  terms and conditions.
                </Text>
              </Text>
            </View>
          </View>
        </View>
      </View>
    </ScrollView>
  );
}
const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    height: 150,
  },
  backButtonContainer: {
    paddingTop: 50,
    flex: 1,
    //paddingLeft: 10,
  },
  forwardButtonContainer: {
    paddingTop: 50,
    flex: 1,
    //paddingLeft: 10
  },
  mainMenuLogoContainer: {
    flex: 3,
    alignSelf: "center",
    alignItems: "center",
    //paddingRight: 90,
    paddingTop: 30,
    paddingLeft: 10,
  },
  mainMenuLogo: {
    height: 70,
    width: 128,
  },
  bodyContainerFull: {
    width: "100%",
  },
  upperTextContainer: {
    marginBottom: 20,
    paddingLeft: 10,
    paddingRight: 10,
    maxWidth: 500,
    alignSelf: "center",
  },

  fuelPartnerTextContainer: {
    alignItems: "center",
    marginTop: 0,
  },
  fuelPartnerTextStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    color: "#757575",
    fontSize: 14,
    fontWeight: "bold",
  },
  fuelPartnerTextStyleBlue: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    color: "#757575",
    fontSize: 10,
  },
  ShellLogoContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 5,
  },
  shellLogo: {
    height: 60,
    width: 150,
    resizeMode: "contain",
  },

  barcodeTextContainer: {
    //marginTop: 5,
    alignItems: "center",
  },

  middelTextContainer: {
    width: "90%",
    alignSelf: "center",
    paddingTop: 10,
    maxWidth: 500,
  },
  termTextContainer: {
    width: "90%",
    alignSelf: "center",
    marginTop: 5,
    maxWidth: 500,
  },
  middelText: {
    color: "#ffff",
    fontFamily: "montserrat-regular",
    textAlign: "center",
    fontSize: 10,
    lineHeight: 13,
  },

  middelTextGrey: {
    color: "#333333",
    fontFamily: "montserrat-regular",
    textAlign: "center",
    fontSize: 10,
    lineHeight: 13,
  },
  
  pleaseText: {
    color: "#ffff",
    fontFamily: "montserrat-regular",
    textAlign: "center",
    fontSize: 10,
    lineHeight: 13,
    paddingLeft: 30,
    paddingRight: 30,
  },
  topText: {
    color: "#ffff",
    fontFamily: "montserrat-regular",
    textAlign: "center",
    fontSize: 13,
    lineHeight: 18,
  },
  threeLogoContainer: {
    alignSelf: "center",
    paddingTop: 20,
    paddingBottom: 15,
  },
  saveIconLogo: {
    height: 169,
    width: 356,
    resizeMode: "contain",
  },
  bottonTextContainer: {
    width: "90%",
    alignSelf: "center",
    paddingTop: 10,
    paddingBottom: 30,
    marginBottom: 40,
    maxWidth: 500,
  },
  footerTextContainer: {
    width: "90%",
    alignSelf: "center",
    paddingTop: 10,
    maxWidth: 500,
  },
  textStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    color: "black",
    textAlign: "center",
    marginBottom: 5,
    maxWidth: 300,
  },
  scrollView: {
    backgroundColor: "#30829e",
  },
  whiteSquareContainerF: {
    backgroundColor: "#FFFFFF",
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingTop: 15,
    height: 249,
  },
  shadowcorners: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomRightRadius: 16,
    borderBottomLeftRadius: 16,
    // paddingLeft: 1,
    // paddingRight: 1,
    // paddingTop: 1,
    // paddingBottom: 1,
    padding: 2,
    width: "100%",
    height: 253,
    alignSelf:"center"
  },
  listPaddingContainer: {
    marginRight: 20,
    marginLeft: 20,
    width: "90%",
    alignSelf:"center",
  },
});
